import backendURLs from '~/misc/backendURLs';

export default (axios, params) => {
  return axios
    .get(backendURLs.creators, { params })
    .then((response) => Promise.resolve(response.data))
    .catch((error) => Promise.reject(error));
};
